
import React from 'react';
import { createPortal } from 'react-dom';

interface WrongGuessModalProps {
    isOpen: boolean;
    onClose: () => void;
    onUseClue: () => void;
    areCluesAllowed: boolean;
}

const WrongGuessModal: React.FC<WrongGuessModalProps> = ({ isOpen, onClose, onUseClue, areCluesAllowed }) => {
    if (!isOpen) {
        return null;
    }

    const pointsDeducted = 1;

    return createPortal(
        <div
            className="fixed inset-0 bg-black/70 z-[9999] flex items-center justify-center p-4 animate-fade-in"
            onClick={onClose}
            role="dialog"
            aria-modal="true"
            aria-labelledby="wrong-guess-title"
        >
            <div
                className="bg-gradient-to-br from-purple-800 to-indigo-900 rounded-2xl shadow-2xl w-full max-w-sm flex flex-col animate-modal-pop-in origin-center text-white border-2 border-purple-500/50"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="relative p-6 text-center">
                    <button onClick={onClose} className="absolute top-2 right-2 text-gray-400 hover:text-white" aria-label="Close">
                        <i className="ph-duotone ph-x text-2xl"></i>
                    </button>
                    
                    <div className="text-6xl mb-4 text-red-400">
                        <i className="ph-duotone ph-x-circle"></i>
                    </div>

                    <h2 id="wrong-guess-title" className="text-3xl font-bold aurora-text mb-2">Not Quite!</h2>
                    
                    <p className="text-lg font-semibold mb-4">
                        That wasn't the right answer.
                    </p>
                    
                    <div className="bg-red-500/80 text-white font-bold py-2 px-4 rounded-full inline-block mb-6">
                        -{pointsDeducted} Point
                    </div>

                    <div className="space-y-3">
                        <button
                            onClick={onClose}
                            className="w-full bg-[var(--accent-pink)] hover:opacity-90 text-white font-bold py-3 px-4 rounded-lg shadow-md"
                        >
                            Try Again
                        </button>
                        {areCluesAllowed && (
                             <button
                                onClick={onUseClue}
                                className="w-full bg-transparent hover:bg-white/10 border border-white/50 text-white font-bold py-3 px-4 rounded-lg shadow-md"
                            >
                                Use a Clue
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default WrongGuessModal;
